import { Anchor, Button, PageHeader, useMatchScreenWidth, XIcon } from '@keplerco/core';
import React, { useEffect, useState } from 'react';
import { ISelectionPanelProps, SelectionEntity } from './selection.models';
import styles from './selection.module.css';
import { OptionButton } from '../../general/option-button/option-button';

export function SelectionPanel<T>({ title, subtitle, entityType, onCancel, onAdd, children, ...props }: ISelectionPanelProps<T>): React.ReactElement {
  const isMobile = useMatchScreenWidth('mobile');

  /* Accessing selectedEntities via props rather than directly to simplify naming */
  const [selectedEntities, setSelectedEntities] = useState<SelectionEntity<T>[]>([]);

  useEffect(() => {
    setSelectedEntities(props.selectedEntities);
  }, [props.selectedEntities]);

  return (
    <div className="panelContent">
      <PageHeader title={title} subtitle={subtitle} divider />

      <div className={styles.body}>
        <div>{children({ selectedEntities, setSelectedEntities })}</div>

        {(!isMobile || !!selectedEntities.length) && (
          <React.Fragment>
            <hr className={styles.divider} />

            <div>
              <h6 style={{ marginBottom: 12 }}>
                Selected {entityType} ({selectedEntities.length})
              </h6>

              <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 12 }}>
                {selectedEntities.map(selectedEntity => (
                  <OptionButton key={selectedEntity.slug} style={{ width: '100%', justifyContent: 'space-between' }} onClick={() => setSelectedEntities(currentState => currentState.filter(currentSelectedEntity => currentSelectedEntity.slug !== selectedEntity.slug))}>
                    {selectedEntity.name}
                    <XIcon size={16} />
                  </OptionButton>
                ))}
              </div>
            </div>
          </React.Fragment>
        )}
      </div>

      <footer className="panelFooter">
        <Anchor onClick={onCancel}>Cancel</Anchor>

        <Button type="button" arrow={false} filled onClick={() => onAdd(selectedEntities)}>
          Add
        </Button>
      </footer>
    </div>
  );
}
